// RESET
export const RESET = 'RESET';

// FETCH_EMPLOYEES
export const FETCH_EMPLOYEES_PENDING = 'FETCH_EMPLOYEES_PENDING';
export const FETCH_EMPLOYEES_FULFILLED = 'FETCH_EMPLOYEES_FULFILLED';
export const FETCH_EMPLOYEES_ERROR = 'FETCH_EMPLOYEES_ERROR';
// STORE_EMPLOYEE
export const STORE_EMPLOYEE_PENDING = 'STORE_EMPLOYEE_PENDING';
export const STORE_EMPLOYEE_FULFILLED = 'STORE_EMPLOYEE_FULFILLED';
export const STORE_EMPLOYEE_ERROR = 'STORE_EMPLOYEE_ERROR';
// DELETE_EMPLOYEE
export const DELETE_EMPLOYEE_PENDING = 'DELETE_EMPLOYEE_PENDING';
export const DELETE_EMPLOYEE_FULFILLED = 'DELETE_EMPLOYEE_FULFILLED';
export const DELETE_EMPLOYEE_ERROR = 'DELETE_EMPLOYEE_ERROR';

// FETCH_EMPLOYEES_ASSIGNMENT
export const FETCH_EMPLOYEES_ASSIGNMENT_PENDING = 'FETCH_EMPLOYEES_ASSIGNMENT_PENDING';
export const FETCH_EMPLOYEES_ASSIGNMENT_FULFILLED = 'FETCH_EMPLOYEES_ASSIGNMENT_FULFILLED';
export const FETCH_EMPLOYEES_ASSIGNMENT_ERROR = 'FETCH_EMPLOYEES_ASSIGNMENT_ERROR';
// STORE_EMPLOYEE_ASSIGNMENT
export const STORE_EMPLOYEE_ASSIGNMENT_PENDING = 'STORE_EMPLOYEE_ASSIGNMENT_PENDING';
export const STORE_EMPLOYEE_ASSIGNMENT_FULFILLED = 'STORE_EMPLOYEE_ASSIGNMENT_FULFILLED';
export const STORE_EMPLOYEE_ASSIGNMENT_ERROR = 'STORE_EMPLOYEE_ASSIGNMENT_ERROR';

// FETCH_EMPLOYEES_REENTER
export const FETCH_EMPLOYEES_REENTER_PENDING = 'FETCH_EMPLOYEES_REENTER_PENDING';
export const FETCH_EMPLOYEES_REENTER_FULFILLED = 'FETCH_EMPLOYEES_REENTER_FULFILLED';
export const FETCH_EMPLOYEES_REENTER_ERROR = 'FETCH_EMPLOYEES_REENTER_ERROR';
// STORE_EMPLOYEE_REENTER
export const STORE_EMPLOYEE_REENTER_PENDING = 'STORE_EMPLOYEE_REENTER_PENDING';
export const STORE_EMPLOYEE_REENTER_FULFILLED = 'STORE_EMPLOYEE_REENTER_FULFILLED';
export const STORE_EMPLOYEE_REENTER_ERROR = 'STORE_EMPLOYEE_REENTER_ERROR';
